(ns hai.interfaces.chrome-sidebar.routes
  (:require [hai.ui.components :as c]
            [hai.web-app.layout :as layout]
            [url.install :as install]))

(defn interfaces-chrome-sidebar-page
  [_]
  [layout/page
   [layout/title-bar
    [c/Heading "Use Humble in your browser sidebar"]]
   [:div [:a {:href install/chrome-store-url
              :target "_blank"} install/chrome-store-url]]])